import React from 'react';
import cs from 'classnames';
import keyBy from 'lodash/keyBy';

import css from './index.css';

const Button = (props) => {
  const mods = props.mods || [];
  const index = keyBy(mods);
  const cn = cs(
    css.button,
    props.className,
    {
      [css.wide]: index.wide,
      [css.action]: index.action,
      [css.large]: index.large,
      [css.small]: index.small,
      [css.disabled]: props.disabled,
      [css.tall]: index.tall,
      [css.huge]: index.huge,
      [css.inputSize]: index.inputSize,
      [css.strench]: index.strench,
    }
  );
  const node = (
    <button
      className={cn}
      onClick={!props.disabled && props.onClick}
      type={props.submit ? 'submit' : 'button'}
      data-qa={props.wrapperClassName ? null : props['data-qa']}
    >{props.children}
    </button>);
  return props.wrapperClassName
    ? <div className={props.wrapperClassName} data-qa={props['data-qa']}>{node}</div>
    : node;
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/index.js